'use client'

import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { DelmanGuard } from '@/features/delman/DelmanGuard'
import { DelmanShell } from '@/shared/layouts/DelmanShell'
import { isSpa } from '@/shared/env'

export function DelmanAppLayout({ children }: { children?: ReactNode }) {
  const content = children ?? (isSpa ? <Outlet /> : null)
  return (
    <DelmanGuard>
      <DelmanShell>{content}</DelmanShell>
    </DelmanGuard>
  )
}
